export default __webpack_public_path__ + "static/media/dispatched_false.e1d14a4a.svg";